import { Component, Input } from "@angular/core"
import { STATIC_IMAGES } from "../../../../models/constants"

@Component({
    selector: "app-collection-card-poster",
    templateUrl: "./collection-card-poster.component.html",
    styleUrls: ["./collection-card-poster.component.scss"],
})
export class CollectionCardPosterComponent {
    @Input() public searchImage = null
    // Deprecated image
    @Input() public posterImage = null
    @Input() public resourceCount = null
    @Input() public alt = null
    @Input() public title = null
    @Input() public gtmPrefix: string = ""
    @Input() public absoluteUrl: string = ""
    @Input() public posterImageDimension?: string = "184px"
    @Input() public showType: boolean = true
    public placeholderImg: string = null

    constructor() {
        this.placeholderImg = STATIC_IMAGES.placeholder_image
    }

    public getCollectionsPosterClass() {
        return `gtm-${this.gtmPrefix}-card`
    }
}
